<nz-modal
  [nzWidth]="'800px'"
  [(nzVisible)]="isNewEditVisible"
  (nzVisibleChange)="onIsNewEditVisibleChange($event)"
  [nzTitle]="selectedItem ? 'Edit Personality' : 'Add New Personality'"
  (nzOnCancel)="onCancelClick()"
  [nzOkText]="null"
  [nzCancelText]="null"
>
  <ng-container *nzModalContent>
    <form nz-form [nzLayout]="'vertical'" [formGroup]="validateForm" (ngSubmit)="submitForm()">
      <nz-form-item>
        <nz-form-label nzRequired nzFor="title">Title</nz-form-label>
        <nz-form-control nzErrorTip="Title required.">
          <div class="horizontal">
            <input nz-input formControlName="title" id="title" [placeholder]="'Your title'" />
          </div>
        </nz-form-control>
      </nz-form-item>

      <nz-form-item>
        <nz-form-label nzRequired nzFor="color">Color</nz-form-label>
        <nz-form-control nzErrorTip="Color required.">
          <app-color-selector-x formControlName="color" [color]="AppColor.orange"></app-color-selector-x>
        </nz-form-control>
      </nz-form-item>

      <nz-form-item>
        <nz-form-label nzFor="personality">Personality</nz-form-label>
        <nz-form-control nzErrorTip="Personality required.">
          <textarea
            nz-input
            formControlName="personality"
            [nzAutosize]="{ minRows: 5, maxRows: 10 }"
            id="personality"
            [placeholder]="'The personality will be used into the customer '"
          ></textarea>
        </nz-form-control>
      </nz-form-item>
    </form>
  </ng-container>

  <div *nzModalFooter class="full-width horizontal seperate">
    <button
      nz-button
      nzType="default"
      [nzDanger]="true"
      nz-popconfirm
      nzPopconfirmTitle="Are you sure you want to delete?"
      nzPopconfirmPlacement="bottom"
      (nzOnConfirm)="onDeleteClick()"
    >
      Delete
    </button>

    <div class="horizontal">
      <button nz-button nzType="default" (click)="onCancelClick()">Cancel</button>
      <button nz-button nzType="primary" (click)="submitForm()">{{ selectedItem ? 'Save' : 'Create' }}</button>
    </div>
  </div>
</nz-modal>
